module.exports = __webpack_public_path__ + "img/grandes-alpes-courchevel_0.c1651248.jpg";